<template>
    <div :class="wrapperClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            width: { type: String, required: true },
            isCenter: { type: Boolean, default: true },
        },

        computed: {
            wrapperClass() {
                return {
                    'content-wrapper': true,
                    'content-wrapper--is-center': this.isCenter,
                    [`content-wrapper--width-${this.width}`]: true,
                }
            },
        },
    }
</script>
